import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { PureButton } from '../../basics';
import styles from './Switch.module.scss';
const Switch = ({ ariaLabel, className, isActive = false, onClick }) => (_jsx(PureButton, { onClick: onClick, className: classNames(className, styles.container, {
        [styles.isActive]: isActive,
        [styles.isInactive]: !isActive,
    }), "aria-checked": isActive, "aria-label": ariaLabel, role: "switch", children: _jsx("div", { className: styles.switch }) }));
export { Switch };
